@if (tabs(); as items) {
  @for (item of items; track trackTab($index, item)) {
    <soft-ds-tab
      [value]="item.value"
      [title]="item.title"
      [icon]="item.icon ?? null"
      [badge]="item.badge ?? null"
      [disabled]="item.disabled ?? false"
    />
  }
} @else {
  <ng-content />
}
@if (variant() === 'underline' || variant() === 'underline-bg') {
  <div
    class="soft-ds-tabs-indicator"
    [class.is-ready]="indicatorReady()"
    [style.left]="indicatorLeft()"
    [style.width]="indicatorWidth()"
  ></div>
}
